import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mainbox" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "more" }
const _hoisted_5 = { class: "mainbox2" }
const _hoisted_6 = { class: "list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { key: 0 }

import { reactive, onMounted, watch, ref } from "vue";
import Nav from "@/components/nav/Index.vue";
import { ArrowRight } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
import { getNewsInfo } from "@/api/backstage";
import { getNwes } from "@/api/backstage";

export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props;
const mb = ref(false);
watch(
  () => props.isMobile,
  (newv, oldv) => {
    props.isMobile ? (mb.value = true) : (mb.value = false);
  }
);
const router = useRouter();
const route = useRoute();
const datas: any = reactive({
  banner: "",
  info: "",
  items: [],
  form: {
    newsType: "NEWS_NEWS",
    pageNum: 1,
    pageSize: 4,
    status: "STATUS_YES",
  },
});

const getList = (id: any) => {
  let form = datas.form;
  form.newsId = id;
  getNwes(datas.form).then((res: any) => {
    for (const item of res.data.list) {
      if (item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    datas.items = res.data.list;
  });
};

const getData = (id: any) => {
  getNewsInfo(id).then((res: any) => {
    datas.info = res.data;
  });
  getList(id);
  window.scrollTo(0, 0);
};

onMounted(() => {
  getData(route.query.id);
  getList(route.query.id);
  mb.value = props.isMobile;
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([mb.value ? 'Mobile' : 'pc', "bg"])
  }, [
    _createVNode(Nav, {
      isMobile: mb.value,
      hasbg: true
    }, null, 8, ["isMobile"]),
    _createVNode(_component_el_breadcrumb, { "separator-icon": _unref(ArrowRight) }, {
      default: _withCtx(() => [
        _createVNode(_component_el_breadcrumb_item, { to: { path: '/home' } }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("首页", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_breadcrumb_item, { to: { path: '/website/news/' } }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("新闻中心", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["separator-icon"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(datas.info.title), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(datas.info.userName) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(datas.info.pushTime), 1)
        ])
      ]),
      _createElementVNode("div", {
        innerHTML: datas.info.content,
        class: "content"
      }, null, 8, _hoisted_3),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "end" }, "END", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", null, "其他新闻", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: index,
              onClick: ($event: any) => (getData(item.id))
            }, [
              _createVNode(_component_el_image, {
                src: item.fileurl,
                fit: "fill"
              }, {
                error: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "icon-tupian iconfont" }, null, -1)
                ]))]),
                _: 1
              }, 8, ["src"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h4", null, _toDisplayString(item.title), 1),
                (!mb.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.createTime), 1))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_7))
          }), 128))
        ])
      ])
    ])
  ], 2))
}
}

})